import uniqueId from '~utils/uniqueId';

export function createTemporaryEntityId() {
  return uniqueId('temp_entity_');
}
